import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { Route, HashRouter as Router, Switch } from 'react-router-dom';
import { i18nIntl, migrate_question } from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton.js';
import BuilderCanvas from '../builder/BuilderCanvas.js';
import BuilderMain from '../builder/BuilderMain.js';
import BuilderSidebar from '../builder/BuilderSidebar.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import Checkbox from '../builder/Checkbox.js';
import { AutoPostImageUploader } from '../builder/ImageUploader.js';
import Model from '../builder/Model.js';
import { NavigationTabsBuilder } from '../builder/NavigationTabs.js';
import Range from '../builder/Range.js';
import Select from '../builder/Select.js';

import { GameContainerWrapper } from '../front/GameContainer.js';
import Layout from '../front/Layout.js';
import PuzzleClient from '../front/PuzzleClient.js';
import CheckEnabler from '../builder/CheckEnabler.js';
import GameInstructionsBuilder from './GameInstructionsBuilder.js';
import GameScoreBuilder from './GameScoreBuilder.js';
import GameSoundtrackFields from '../builder/GameSoundtrackFields.js';

const GameSettings = ({ stage, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ errors_game, setErrorsGame ] = useState({});

	const option_level = [
		{ k:'easy', v:i18n("Easy") },
		{ k:'normal', v:i18n("Medium") },
		{ k:'hard', v:i18n("***Hard") },
	];

	const getMinAttemps = () => {
		const level = stage?.puzzle_level ?? 'easy';

		switch(level) {
			case 'hard':
				return 5;

			case 'normal':
				return 4;

			case 'easy':
				return 3;
		}

		return 3;
	};

	const min_attempts = Math.pow(getMinAttemps(), 2);

	const puzzleChange = (k,v) => {

		if (k == 'puzzle_level') {
			let attempts = 9;
			if (v == 'normal') attempts = 16;
			if (v == 'hard') attempts = 25;
			
			if (stage?.game_attempts != undefined && stage?.game_attempts < attempts ) {
				change('game_attempts',attempts);
			}
		}
		change(k,v);
	}

	return (
		<>
			<BuilderSidebar
				onSave={props.saveStage}
				errors={(Object.keys(errors_game).length > 0) ? true : false}
			>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<article>
					<Model model={stage} change={puzzleChange}>
						<Select
							_class={{ size:70, first:true }}
							name="puzzle_level"
							values={option_level}
						>Level</Select>

						<Checkbox
							name="display_legend"
							value={stage?.display_legend ?? true}
						>Show help</Checkbox>

						<Checkbox
							name="display_outter_border"
							value={stage?.display_outter_border ?? true}
						>Display outer border</Checkbox>

						<Range
							min={30}
							max={300}
							step={5}
							label_props={{
								addition:"In seconds",
							}}
							name="game_time"
							value={Math.max((stage?.game_time ?? 60), 30)}
						>Time limit</Range>

						<CheckEnabler 
							label="Limit moves"
							enabled={(stage?.game_attempts > 0) ? true : false}
							onDisable={() => change('game_attempts', "")}
							onEnable={() => change('game_attempts', min_attempts)}
						>
							<Range
								model={stage}
								change={change}
								min={min_attempts}
								max={50}
								step={1}
								name="game_attempts"
								value={Math.max((stage?.game_attempts ?? 1), min_attempts)}
							>Max. number of attempts/moves</Range>
						</CheckEnabler>
						{/* <Checkbox
							name="game_attempts_enabled"
						>Limit moves</Checkbox>

						{(stage?.game_attempts_enabled ?? false) && (
							<Range
								min={min_attempts}
								max={50}
								step={1}
								name="game_attempts"
								value={Math.max((stage?.game_attempts ?? 1), min_attempts)}
							>Max. number of attempts/moves</Range>
						)} */}

						<AutoPostImageUploader
							auto_url={`/promotions/auto_img/${props.promotion.id}`}
							auto_type='stages'
							name="puzzle_image"
							image={stage.full_puzzle_image}
							display_custom_dragging_instructions="Upload the image"
							small_input={true}
							_size={{ width:800, height:800 }}
						>Image</AutoPostImageUploader>

						<Checkbox
							name='silence'
						>Disable sounds</Checkbox>
					</Model>

					<GameSoundtrackFields
						stage={stage}
						change={change}
					/>
				</article>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout
					promo={props.promotion}
					is_builder={true}
					page="quiz"
					menus={props.promoModel.Custom__Menus}
					layout_extra_classes="is_new_game"
				>
					<div style={{width:'100%'}}>
						{(Object.keys(errors_game).length == 0) ? (
							<PuzzleClient
								stage={{ Stage:stage }}
								is_builder={true}
								is_playable={true}
								section="settings"
								key={stage.puzzle_level}
							/>
						) : (
							<GameContainerWrapper>
								<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
									{Object.values(errors_game).map((error, i) => {
										if(typeof error === 'object') return null;

										return (
											<p key={`error${i}`}>{error}</p>
										)
									})}
								</div>
							</GameContainerWrapper>
						)}
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
};

const GameTest = ({ stage, change, ...props }) => {
	const restart = () => {
		change('reset', (stage.reset != undefined) ? (stage.reset + 1) : 0);
	};

	return (
		<>
			<BuilderSidebar
				onSave={props.saveStage}
			>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<ButtonCollection>
					<ActionButton
						icon='knk-reload'
						onClick={() => restart()}
					>Restart game</ActionButton>
				</ButtonCollection>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout
					promo={props.promotion}
					is_builder={true}
					page="quiz"
					menus={props.promoModel.Custom__Menus}
					layout_extra_classes="is_new_game"
				>
					<div style={{width:'100%'}}>
						<PuzzleClient
							stage={{ Stage:stage }}
							is_builder={true}
							is_playable={true}
							is_test={true}
						/>
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
};

const PuzzleBuilder = ({ base_route, ...props }) => {
	const basename = `/stages/${props.stage.id}/puzzle`;
	const nav_sections = [
		{ label:"Go back", link:`/stages/${props.stage.id}/options`, icon:'knk-go-prev' },
		{ label:"Gameplay settings", link:`${basename}/settings`, icon:'knk-settings' },
		{ label:"Instructions", link:`${basename}/instructions`, icon:'knk-help' },
		{ label:"Score screen", link:`${basename}/gamescore`, icon:'knk-like' },
		{ label:"Test the game", link:`${basename}/test`, icon:'knk-ok' },
	];

	const stage = props.stage;

	const migrate_from_question = true;
	if(migrate_from_question) {
		const question = props.questionStore.getState()?.questions.questions.find((q) => (q.Question.stage == props.stage.id));

		const game_stage_fields_map = {
			images:'puzzle_image',
			time_seconds:'game_time',
			attempts:'game_attempts',
			display_legend:'display_legend',
			level:'puzzle_level',
			instructions_img:'instructions_img',
			full_instructions_img:'full_instructions_img',
		};
		if (question) {
			const migrated = migrate_question(game_stage_fields_map, stage, question?.Question);
			if(migrated) props.saveStage();
		}
	};

	const common_props = {
		stage,
		is_multistage:props.is_multistage,
		isCorporate:props.isCorporate,
		change:props.change,
		changeMulti:props.changeMulti,
		intl:props.intl,
		promotion:props.promotion,
		promoModel:props.promoModel,
		saveStage:props.saveStage,
		stage_indicator:props.stage_indicator,
		nav_sections:nav_sections,
	};

	return (
		<BuilderMain pm={props.promoModel}>
			<Router basename={basename} hashType="noslash">
				<Switch>
					<Route exact={true} path="/settings">
						<GameSettings
							{...common_props}
							nav_active={`/settings`}
						/>
					</Route>

					<Route exact={true} path="/instructions">
						<GameInstructionsBuilder
							{...common_props}
							nav_active={`/instructions`}
						>
							<PuzzleClient
								stage={{ Stage:props.stage }}
								promotion={props.promotion}
								is_builder={true}
								section="instructions"
							/>
						</GameInstructionsBuilder>
					</Route>

					<Route exact={true} path="/gamescore">
						<GameScoreBuilder
							{...common_props}
							nav_active={`/gamescore`}
							exclude_cases={['fail']}
						>
							<PuzzleClient
								stage={{ Stage:props.stage }}
								promotion={props.promotion}
								is_builder={true}
								section="score"
							/>
						</GameScoreBuilder>
					</Route>

					<Route exact={true} path="/test">
						<GameTest
							{...common_props}
							nav_active={`/test`}
						/>
					</Route>
				</Switch>
			</Router>
		</BuilderMain>
	)
}
export default injectIntl(PuzzleBuilder);